import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton,} from "@mui/x-data-grid";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Drawer from "../../components/common/drawer/drawer";
import { Typography, Button, Checkbox, Fab, IconButton, Stack } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { Add } from "@mui/icons-material";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import SchoolCategoryModal from "../../components/modals/PicklistModals/schoolCategoryModal";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import OlympiadClassSubjectMappingModal from "../../components/modals/OlympiadClassSubjectMappingModal";

const isMobile = window.innerWidth < 900;

const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile &&
  `
      position: relative;
  
      `}
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${isMobile ? "flex-start" : "space-between"};
  margin-bottom: 10px;
  flex-direction: ${isMobile ? "column" : "row"};
`;

const TableContainer = styled.div`
  height: calc(
    100vh - ${isMobile ? "56px - 20px - 82.23px" : "100px - 20px - 43.77px"}
  );
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
`;

const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  height: calc(100% );
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
  display: ${isMobile ? 'flex' : 'grid'};

  ${isMobile &&
  `
    flex-direction: column;
  `}
`;

export default function OlympiadClassSubjectMapping() {

  const [loading, setLoading] = useState(false);
  const [accessChanges, setAccessChanges] = useState("");
  const [visitModal, setVisitModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [dataModal, setDataModal] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    getAllClassSubjectMappings();
  }, []);

 const getAllClassSubjectMappings = async () => {
  setLoading(true);
  try {
    let results = await window.Platform.database.getAllClassSubjectMappings();

    // ── Group by class_id ──
    const groupedMap = {};
    (results?.data || []).forEach((obj) => {
      if (!groupedMap[obj.class_id]) {
        groupedMap[obj.class_id] = {
          id: obj.class_id,           // DataGrid needs unique id
          dbId: obj.class_id,
          class_id: obj.class_id,
          class_name: obj.class_name,
          subjects: [],               // array of { id, subject_id, subject_name }
        };
      }
      groupedMap[obj.class_id].subjects.push({
        id: obj.id,
        subject_id: obj.subject_id,
        subject_name: obj.subject_name,
      });
    });

    const grouped = Object.values(groupedMap).sort((a, b) => a.class_id - b.class_id);
    setAccessChanges(grouped);
  } catch (error) {
    console.error("ERRORCHECK", error);
    window.NotificationUtils.showError("Error Fetching Data");
  } finally {
    setLoading(false);
  }
};

  const handleDelete = async (row) => {
  const isConfirmed = window.confirm(
    `Are you sure you want to delete all mappings for ${row.class_name}?`
  );
  if (!isConfirmed) return;

  try {
    setLoading(true);
    await window.Platform.database.deleteClassSubjectMapping({ class_id: row.class_id });
    window.NotificationUtils.showSuccess("Mapping deleted successfully!");
    getAllClassSubjectMappings();
  } catch (error) {
    console.error(error);
    window.NotificationUtils.showError("Failed to delete");
  } finally {
    setLoading(false);
  }
};

 const getClusterColumns = () => [
  {
    field: "class_name",
    headerName: "Class Name",
    width: 200,
    sortable: false,
    renderCell: (params) => (
      <Tooltip title={params.row?.class_name || "N/A"}>
        <Typography variant="inherit" sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}>
          {params.row?.class_name || "N/A"}
        </Typography>
      </Tooltip>
    ),
  },
  {
    field: "subjects",
    headerName: "Mapped Subjects",
    flex: 1,
    sortable: false,
    renderCell: (params) => (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, py: 0.5 }}>
        {(params.row?.subjects || []).map((subj) => (
          <Box
            key={subj.subject_id}
            sx={{
              background: "#e3f2fd",
              color: "#1565c0",
              borderRadius: "12px",
              px: 1.2,
              py: 0.3,
              fontSize: "12px",
              fontWeight: 500,
              whiteSpace: "nowrap",
            }}
          >
            {subj.subject_name}
          </Box>
        ))}
      </Box>
    ),
  },
  {
    field: "actions",
    headerName: "Actions",
    sortable: false,
    width: 120,
    renderCell: (params) => (
      <>
        <Tooltip title="Edit">
          <IconButton onClick={() => handleEdit(params.row)}>
            <DriveFileRenameOutlineIcon sx={{ color: "black", fontSize: "22px" }} />
          </IconButton>
        </Tooltip>
        {/* <Tooltip title="Delete">
          <IconButton
            onClick={() => handleDelete(params.row)}
            disabled={accessChanges?.length === 1}
          >
            <DeleteIcon sx={{ color: "Red", fontSize: "22px" }} />
          </IconButton>
        </Tooltip> */}
      </>
    ),
  },
];

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        {/* <GridToolbarColumnsButton />
        <GridToolbarFilterButton /> */}
      </GridToolbarContainer>
    );
  }

  const renderContent = () => {
    return (
      <Box sx={{ height: "100%", width: "100%" }}>
        <DataGridContainer>
          <DataGrid
            className="payrollGrid"
            density="compact"
            rows={accessChanges || []}
            columns={getClusterColumns()}
             sx={{color:"black", fontSize:"14px", fontWeight:"600"}}
            rowHeight={60}
            disableSelectionOnClick
            disableRowSelectionOnClick
            autoPageSize
            components={{
              Toolbar: CustomToolbar,
            }}
            // pageSizeOptions={[10]}
          />
        </DataGridContainer>
      </Box>
    );
  };

  const addVisit = () => {
    setVisitModal(true);
  }

const handleEdit = (row) => {
  setEditModal(true);
  setDataModal({
    class_id: row.class_id,
    subject_ids: row.subjects.map((s) => s.subject_id), // ← extract all subject_ids
  });
};

  const goBack = () => {
    navigate(-1);
  }

  return (
    <>
      {isMobile && (
        <Drawer />
      )}
      <StaffEditorPageContainer>
        {loading && <OpaqueLoading />}
        <HeaderContainer>
          <div>
            <Button variant="outlined" onClick={goBack} sx={{ mb: 2 }}>
             <ArrowBackIcon sx={{marginRight:"2px"}}/> Back
            </Button>
          </div>

          <Stack direction={"row"} spacing={2} >
            <Button variant="contained" color="primary"
              onClick={() => addVisit()} sx={{ mr: 1, borderRadius: '10px' }}>
              <Add sx={{ mr: 1 }} />
              Add New
            </Button>
          </Stack>

        </HeaderContainer>
        <TableContainer>{renderContent()}</TableContainer>
      </StaffEditorPageContainer>
      {
        visitModal &&
        <OlympiadClassSubjectMappingModal
          onClose={() => setVisitModal(false)}
          loading={loading}
          fetchData={() => getAllClassSubjectMappings()}
          status={true}
        />
      }
      {
        editModal &&
        <OlympiadClassSubjectMappingModal
          onClose={() => setEditModal(false)}
          loading={loading}
          fetchData={() => getAllClassSubjectMappings()}
          status={false}
          propData={dataModal}
        />
      }

    </>
  );
}
